import { EditorNode } from '../core/EditorNode';

export class RemixNode extends EditorNode {
  constructor() {
    super('remix');
  }

  match(element) {
    return element.getAttribute('data-type') === 'remix';
  }

  render(data, context = {}) {
    const { makeDraggable } = context;
    const { id, name } = data;

    const container = document.createElement('span');
    container.contentEditable = 'false';
    container.setAttribute('data-type', 'remix');
    container.setAttribute('data-remix-id', id);
    container.setAttribute('data-remix-name', name);
    container.setAttribute('data-value', `@VeesoRemix('${id}', '${name}')`);

    // Style: Violet/Purple theme for Remix
    container.className =
      'remix-tag inline-flex items-center gap-1.5 mx-0.5 px-1.5 py-0.5 rounded-full select-none align-baseline transition-all duration-200';

    // Custom style
    container.style.cssText = `
      background-color: rgba(139, 92, 246, 0.1);
      color: #7c3aed;
      font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo, Monaco, Consolas, monospace;
      font-size: 0.8125em;
      font-weight: 500;
      letter-spacing: -0.01em;
      line-height: 1.4;
      border: 1px solid rgba(139, 92, 246, 0.25);
      border-radius: 9999px;
      transition: all 0.2s ease;
      cursor: default;
    `;

    if (makeDraggable) {
      makeDraggable(container);
    }

    // Icon
    const icon = document.createElement('span');
    icon.innerHTML = `<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>`;
    icon.style.display = 'flex';
    icon.style.alignItems = 'center';

    const textSpan = document.createElement('span');
    textSpan.textContent = name || 'Untitled Remix';
    textSpan.className = 'pointer-events-none';

    container.appendChild(icon);
    container.appendChild(textSpan);
    return container;
  }

  update(element, data, context) {
    const parent = element.parentNode;
    if (!parent) return;

    const newNode = this.render(data, context);
    parent.replaceChild(newNode, element);
  }

  serialize(element) {
    const id = element.getAttribute('data-remix-id');
    const name = element.getAttribute('data-remix-name');
    return `@VeesoRemix('${id}', '${name}')`;
  }
}
